/// Menu
import React, { useContext, useReducer, useState, useEffect, useMemo } from "react";
import Collapse from 'react-bootstrap/Collapse';


/// Link
import { Link, useLocation } from "react-router-dom";

import {MenuList} from './Menu';
import { canViewModule } from '../../../services/AuthService';
import {useScrollPosition} from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { useTranslation } from 'react-i18next';


const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active : "",
  activeSubmenu : "",
}

const SideBar = () => {
  const { t } = useTranslation();
	const { pathname } = useLocation();
	const {
		iconHover,
		sidebarposition,
		headerposition,
		sidebarLayout,
    ChangeIconSidebar,
	} = useContext(ThemeContext);

	const isActive = (to) => {
		if (!to) return false;
		const cleanPath = pathname.replace(/^\/+/, '') || 'dashboard';
		const cleanTo = to.replace(/^\/+/, '');
		if (cleanTo === 'dashboard') return cleanPath === 'dashboard' || cleanPath === '';
		if (cleanTo === 'orders/statistics') return cleanPath === 'orders/statistics';
		if (cleanTo === 'orders') return cleanPath === 'orders' || (cleanPath.startsWith('orders/') && !cleanPath.startsWith('orders/statistics') && cleanPath !== 'orders/marketing');
		// Only exact match: Recipes and Nutrition Facts are separate menu items
		return cleanPath === cleanTo;
	};

  // Menu items visible to the current user: top-level entries filtered by their own
  // moduleKey (standalone items), and for section entries, their `content` children
  // filtered individually — a section is hidden entirely if none of its children are
  // visible (e.g. a role that can't see any Users sub-page never sees the Users group).
  const visibleMenu = useMemo(() => {
    return MenuList
      .filter((data) => !data.moduleKey || canViewModule(data.moduleKey))
      .map((data) => {
        if (!data.content) return data;
        const visibleChildren = data.content.filter((child) => !child.moduleKey || canViewModule(child.moduleKey));
        return { ...data, content: visibleChildren };
      })
      .filter((data) => !data.content || data.content.length > 0);
  }, []);

  // Title (translated) of the section whose child route matches the current pathname —
  // used to auto-expand that section so users don't lose track of where they are when
  // landing directly on a sub-page (e.g. /recipes/nutrition-facts).
  const activeSectionTitle = useMemo(() => {
    for (const data of visibleMenu) {
      if (data.content && data.content.some((child) => isActive(child.to))) {
        return t(data.titleKey);
      }
    }
    return "";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visibleMenu, pathname, t]);

  // Lazy initializer so the correct section is already expanded on first paint
  // (no flash of a collapsed section that immediately springs open).
  const [state, setState] = useReducer(reducer, activeSectionTitle, (initialActive) => ({
    ...initialState,
    active: initialActive,
  }));

  // Keep the section containing the active route expanded on subsequent client-side
  // navigation too (SideBar doesn't remount between routes).
  useEffect(() => {
    if (activeSectionTitle) {
      setState({ active: activeSectionTitle });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeSectionTitle]);

 //For scroll
 	const [hideOnScroll, setHideOnScroll] = useState(true)
	useScrollPosition(
		({ prevPos, currPos }) => {
		  const isShow = currPos.y > prevPos.y
		  if (isShow !== hideOnScroll) setHideOnScroll(isShow)
		},
		[hideOnScroll]
	)


  const handleMenuActive = status => {
    setState({active : status});
		if(state.active === status){
      setState({active : ""});
    }
	}
	// Menu dropdown list End

  return (
    <div
      onMouseEnter={()=>ChangeIconSidebar(true)}
      onMouseLeave={()=>ChangeIconSidebar(false)}
      className={`deznav  border-right ${iconHover} ${
        sidebarposition.value === "fixed" &&
        sidebarLayout.value === "horizontal" &&
        headerposition.value === "static"
          ? hideOnScroll > 120
            ? "fixed"
            : ""
          : ""
      }`}
    >
        <div className="deznav-scroll">
            <ul className="metismenu" id="menu">
              {visibleMenu.map((data, index)=>{
                const title = data.titleKey ? t(data.titleKey) : data.title;
                let menuClass = data.classsChange;
                  if(menuClass === "menu-title"){
                    return(
                      <li className={menuClass}  key={index} >{title}</li>
                    )
                  }else{
                    return(
                      <li className={` ${ state.active === title || (data.to && isActive(data.to) && !data.content) ? 'mm-active' : ''}`}
                        key={index}
                      >

                        {data.content && data.content.length > 0 ?
                            <>
                              <Link to={"#"}
                                className="has-arrow"
                                onClick={() => {handleMenuActive(title)}}
                                >
                                  <span className="nav-text">{title}
                                  {
                                    data.update && data.update.length > 0 ?
                                      <span className="badge badge-xs badge-danger ms-2">{data.update}</span>
                                    :
                                    ''
                                  }
                                </span>
                              </Link>
                              <Collapse in={state.active === title ? true :false}>
                                  <ul className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}>
                                    {data.content.map((child,cIndex) => {
                                      return(
                                          <li key={cIndex}>
                                            <Link
                                              to={child.to}
                                              className={isActive(child.to) ? 'mm-active' : ''}
                                            >
                                              {child.titleKey ? t(child.titleKey) : child.title}
                                            </Link>
                                          </li>
                                      )
                                    })}
                                  </ul>
                                </Collapse>
                            </>
                        :
                          <Link to={data.to}>
                              <span className="nav-text">{title}</span>
                              {
                                  data.update && data.update.length > 0 ?
                                    <span className="badge badge-xs badge-danger ms-2">{data.update}</span>
                                  :
                                  ''
                                }
                          </Link>
                        }

                      </li>
                    )
                }
              })}
          </ul>
        </div>
    </div>
  );
};

export default SideBar;
